'use strict'
const minimumLoadTime = 500

const minimatch = require('minimatch')
//const nav = require('../script/nav')

function isIncluded(el, exclude, excludeFrom){
	for(let i = exclude.length; i--;){
		if(selectorMatches(el, exclude[i])){
			return false
		}
	}
	const href = el.getAttribute('href')
	if(!href || href.indexOf('#') === 0) return false
	for(let i = excludeFrom.length; i--;){
		if(minimatch(href, excludeFrom[i])){
			return false
		}
	}
	return true
}

function selectorMatches(el, selector) {
	const p = Element.prototype
	const f = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.msMatchesSelector || function(s){
		return [].indexOf.call(document.querySelectorAll(s), this) !== -1
	}
	return f.call(el, selector)
}


// Request a page and load/unload modules
let loadingPage = false
function loadPage(href, $this, cb, noHistory){

	if(loadingPage === true) return

	if(href === location.pathname && !noHistory){
		$this.resetScrollPosition(cb)
		return
	}

	loadingPage = true

	// Show load state
	$this.loader.classList.add('active')

	// Remove content
	$this.container.classList.remove('showContent')
	$this.container.classList.add('hideContent')

	// Unload current module
	$this.unloadModule()

	const startTime = new Date()

	var req = new XMLHttpRequest()
	req.onreadystatechange = () => {
		if(req.readyState === XMLHttpRequest.DONE){
			if(req.status === 200){
				try{

					// Parse new DOM
					let newDom = new DOMParser()
					newDom = newDom.parseFromString(req.responseText, 'text/html')
					


					let duration = minimumLoadTime - (new Date() - startTime)
					if(duration <= 0){
						process()
					}
					else{
						setTimeout(process, duration)
					}



					function process(){

						// Change body attributes
						newDom.body.classList.remove('noJs')
						document.body.removeAttribute('data-module')
						document.body.className = newDom.body.className
						if(newDom.body.dataset.module){
							document.body.dataset.module = newDom.body.dataset.module
						}

						// Change page title
						const title = newDom.querySelector('title').textContent
						document.querySelector('title').textContent = title

						// Change content
						$this.container.innerHTML = newDom.querySelector('main').innerHTML

						// Scroll up
						document.documentElement.scrollTop = document.body.scrollTop = 0

						// Hijack new links
						$this.processLinks()

						// Google analytics
						if('ga' in window){
							ga('send', 'pageview', href)
						}

						// Change history state
						if(!noHistory){
							history.pushState(false, title, href)
						}
						else if(typeof noHistory === 'string'){
							history.pushState(false, title, href)
						}

						// Find new script files
						const scripts = newDom.getElementsByTagName('script')
						for(let i = scripts.length; i--;){
							const src = scripts[i].getAttribute('src')
							if($this.scripts.indexOf(src) === -1){
								document.body.appendChild(scripts[i])
								$this.scripts.push(src)
							}
						}

						// Find new styles files
						const styles = newDom.querySelectorAll('link[rel="stylesheet"]')
						for(let i = styles.length; i--;){
							const href = styles[i].getAttribute('href')
							if($this.styles.indexOf(href) === -1){
								document.head.appendChild(scripts[i])
								$this.styles.push(href)
							}
						}

						// Load new modules
						$this.loadSiteModules(() => {

							$this.loadModule(() => {

								// Hide load state
								$this.loader.classList.remove('active')

								// Close nav
								//nav.close()

								// Show content
								$this.container.classList.add('showContent')
								$this.container.classList.remove('hideContent')

								// Release state
								loadingPage = false
								if(cb) cb()

							})
						})
					}



				}
				catch(e){
					// In case a module threw an error, start with clean memory
					location.href = href
				}
			}
			else{
				// Let the server handle any error rendering just in case
				location.href = href
			}
		}
	}
	req.open('GET', `${href}?xhr=1`, true)
	
	req.send({ xhr: true })
	//setTimeout(() => req.send(), 500)
}

const main = module.exports = function(options, cb){
	options = Object.assign({
		container: document.querySelector('main'),
		scrollTime: 500,
		excludeLinks: [],
		excludeFrom: [],
		siteModules: []
	}, options)
	for(let i in options){
		this[i] = options[i]
	}
	const $this = this

	this.modules = []

	// Link click events
	this.click = function(e){
		if(
			(!e.which || e.which === 1) &&
			!e.metaKey
		){
			e.preventDefault()
			loadPage(this.getAttribute('href'), $this, cb)
		}
	}

	// History API
	window.onpopstate = function(e){
		loadPage(document.location.pathname, $this, cb, true)
	}

	// Create load element
	this.loader = document.createElement('div')
	this.loader.classList.add('loader')
	this.loader.innerHTML = '<div class="spinner"><div class="double-bounce1"></div><div class="double-bounce2"></div></div>'
	document.body.appendChild(this.loader)

	// Store scripts
	const scripts = document.getElementsByTagName('script')
	this.scripts = []
	for(let i = scripts.length; i--;){
		this.scripts.push(scripts[i].getAttribute('src'))
	}

	// Store styles
	const styles = document.querySelectorAll('link[rel="stylesheet"]')
	this.styles = []
	for(let i = styles.length; i--;){
		const href = styles[i].getAttribute('href')
		if(href){
			this.styles.push(href)
		}
	}

	// Intercept link click events
	if(this.disable !== true){
		this.processLinks()
	}

	// Load all site modules
	this.loadSiteModules()

	// Load current module
	this.loadModule()

}
main.prototype = {
	// Find and replace all link click events to laod via ajax
	processLinks: function(){
		for(let i = this.excludeFrom.length; i--;){
			if(minimatch(location.pathname, this.excludeFrom[i])){
				return
			}
		}
		const els = document.querySelectorAll('a:not(data-processed)')
		for(let i = els.length; i--;){
			if(isIncluded(els[i], this.excludeLinks, this.excludeFrom)){
				els[i].addEventListener('click', this.click)
			}
			els[i].dataset.processed = true
		}
	},
	// Load any modules that might be needed for the page
	loadModule: function(cb, module){
		const promises = []
		const modules = this.modules
		modules.length = 0
		for(let i in this.pageModules){
			if(minimatch(document.location.pathname, i)){
				let arr = this.pageModules[i]
				if(!Array.isArray(arr)){
					arr = [ arr ]
				}
				for(let i = 0; i < arr.length; i++){
					promises.push(new Promise((resolve, reject) => {
						if(arr[i].prototype.load){
							const module = new arr[i]
							modules.push(module)
							module.load(resolve)
						}
						else{
							arr[i](resolve)
						}
					}))
				}

			}
		}
		Promise.all(promises)
			.then(cb)
			.catch(console.error)
	},
	// Unload any module that might be needed for the page
	unloadModule: function(cb, module){
		if(this.modules){
			for(let i = this.modules.length; i--;){
				if('unload' in this.modules[i]) this.modules[i].unload()
			}
		}
	},
	loadSiteModules: function(cb){
		const promises = []
		for(let i = 0; i < this.siteModules.length; i++){
			promises.push(new Promise(this.siteModules[i]))
		}
		Promise.all(promises)
			.then(() => {
				if(cb) cb()
			})
			.catch(console.error)
	},
	resetScrollPosition: function(cb){
		const originPosition = window.pageYOffset || document.documentElement.scrollTop
		if(!originPosition){
			if(cb) cb()
			return
		}
		let position = originPosition
		let easePosition
		let startingTime
		let delta
		const $this = this
		function frame(time){
			if(!startingTime){
				startingTime = time
				requestAnimationFrame(frame)
			}
			else{
				time = time - startingTime
				if(time >= $this.scrollTime){
					document.documentElement.scrollTop = document.body.scrollTop = 0
					if(cb) cb()
				}
				else{
					easePosition = originPosition - (easing(time / $this.scrollTime) * originPosition)
					document.documentElement.scrollTop = document.body.scrollTop = easePosition
					requestAnimationFrame(frame)
				}
			}
		}
		requestAnimationFrame(frame)
	}
}

function easing(t){
	return t*(2-t)
}